<template>
  <div
    v-if="isClinician"
    class="
      flex flex-col
      justify-center
      bg-vice-light-grey
      rounded-lg
      text-center
      px-9
      py-8
      w-full
      max-w-2xl
    "
  >
    <h1 class="text-vice-teal-900 text-xl font-bold pb-3">
      Thank you for hosting this CE session!
    </h1>
    <p class="text-vice-teal-900 text-base font-medium leading-6 mx-auto mb-5 max-w-xl">
      You have concluded the session and can now close this window.
    </p>
    <div class="flex flex-col gap-4 max-w-lg w-full mx-auto">
      <ViceButton
        data-cy="clinician-close-session-window"
        onclick="window.close()"
        icon="XIcon"
        class="justify-center step-close-session"
        white
      >
        Close this Window
      </ViceButton>
    </div>
  </div>
  <div
    v-else
    class="wrapper flex flex-col justify-center bg-vice-light-grey rounded-lg text-center px-9 py-8"
  >
    <h1 class="text-vice-teal-900 text-xl font-bold pb-3">Thank you for your participation!</h1>
    <p class="text-vice-teal-900 text-base font-medium leading-6 mx-auto mb-5">
      Your CE Clinician has concluded the session and you can now close this window.
    </p>

    <div class="flex flex-col gap-4 max-w-lg w-full mx-auto">
      <ViceButton
        @click="closeIntercom()"
        data-cy="research-survey-link"
        :href="'/session/details/' + sessionId + '?tab=reflection'"
        icon="PencilIcon"
        class="justify-center"
        white
      >
        Please provide your reflections on the session
      </ViceButton>

      <ViceButton
        @click="closeIntercom()"
        data-cy="participant-close-session-window"
        :href="'/session/details/' + sessionId + '?tab=overview'"
        icon="XIcon"
        class="justify-center"
        white
      >
        Close this window
      </ViceButton>
    </div>
  </div>
</template>

<script>
import { hide } from '@intercom/messenger-js-sdk';
import ViceButton from '@/Components/Buttons/ViceButton';
import useTourManager from '@/Composables/useTourManager';
import { clinicianSessionEndTourSteps } from '@/Data/tourSteps';

const clinicianSessionEndTour = useTourManager(
  'clinicianSessionEndTour',
  clinicianSessionEndTourSteps,
);
export default {
  components: {
    ViceButton,
  },
  props: {
    isClinician: {
      type: Boolean,
      required: true,
      default: true,
    },
    sessionId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    setTimeout(() => {
      clinicianSessionEndTour.startTour();
    }, 200);
  },
  data() {
    return {
      url: process.env.MIX_SURVEY_URL,
    };
  },
  methods: {
    closeIntercom() {
      hide();
    },
  },
};
</script>
